export enum REDOC_CONNECT_RESPONSE_TYPE {
  CODE = 'code',
  ID_TOKEN = 'id_token',
}
